
import { CardData, Difficulty, TournamentTrick } from './types';
import { BKC_2025_BEGINNER_LV1, BKC_2025_BEGINNER_LV2, BKC_2025_BEGINNER_LV1_2, BKC_2025_ADVANCED_LV1, BKC_2025_ADVANCED_LV2, BKC_2025_ADVANCED_LV1_2 } from './data/decks/battle/bkc_2025';
import { SKC_2026_NOVICE, SKC_2026_ADVANCED, SKC_2026_PRO } from './data/decks/battle/skc_2026';
import { STARCITY_WINTER_2025_TRICKS } from './data/decks/point/starcity_winter_2025';
import { KWC2025_TRICKS } from './data/decks/point/kwc_2025';
import { KWC2026_TRICKS } from './data/decks/point/kwc_2026';
import { CKO2025_TRICKS } from './data/decks/point/cko_2025';
import { CKO2026_TRICKS } from './data/decks/point/cko_2026';

export const WINNING_SCORE = 3;
export const MAX_ATTEMPTS = 3;

// Re-export the imported lists so other files importing them from constants.ts still work
export { 
  BKC_2025_BEGINNER_LV1, 
  BKC_2025_BEGINNER_LV2, 
  BKC_2025_BEGINNER_LV1_2, 
  BKC_2025_ADVANCED_LV1, 
  BKC_2025_ADVANCED_LV2, 
  BKC_2025_ADVANCED_LV1_2,
  SKC_2026_NOVICE,
  SKC_2026_ADVANCED,
  SKC_2026_PRO,
  STARCITY_WINTER_2025_TRICKS,
  KWC2025_TRICKS,
  KWC2026_TRICKS,
  CKO2025_TRICKS,
  CKO2026_TRICKS
};

export const createDeckFromNames = (names: string[], difficultyPrefix: string): CardData[] => {
  return names.map((name, index) => ({
    id: `${difficultyPrefix}-${index}`,
    name: name,
    difficulty: 'CUSTOM' as Difficulty,
    isCompleted: false
  }));
};

export const getDeck = (
  difficulty: Difficulty, 
  customTricks: string[] = []
): CardData[] => {
  const names = customTricks.length > 0 ? customTricks : ['自由'];
  return createDeckFromNames(names, difficulty);
};

export const INITIAL_DECK: CardData[] = getDeck('CUSTOM', ['自由']);
